import React from "react";
import { SVG, IconProps } from "../SVG";

export const ChatBubble = ({ color = "#3667E9", ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M1-2h20v20H1z" />
            <path d="M14.616 2.2H8.384C5.25 2.2 2.7 4.576 2.7 7.498c0 2.048 1.288 3.932 3.282 4.8l.718.316v2.632l2.47-2.154.33-.296h5.116c3.134 0 5.684-2.376 5.684-5.298S17.75 2.2 14.616 2.2ZM7.444 9a1.15 1.15 0 1 1 1.142-1.134 1.146 1.146 0 0 1-1.142 1.128V9Zm4.044 0a1.15 1.15 0 1 1 1.16-1.144 1.162 1.162 0 0 1-1.16 1.138V9Zm4.068 0A1.15 1.15 0 1 1 16.7 7.836a1.148 1.148 0 0 1-1.144 1.158V9Z" />
            <path
                fill={color}
                fillRule="nonzero"
                stroke={color}
                strokeWidth={0.4}
                d="M14.116 1H7.884C4.082 1 1 3.91 1 7.498c0 2.618 1.64 4.872 4 5.902v2.368c0 .728.288 1.12.726 1.12.35-.034.676-.19.922-.44l2.8-2.452h4.668c3.8 0 6.884-2.91 6.884-6.498S17.918 1 14.116 1Zm0 11.8H9l-.34.296-2.46 2.15v-2.632l-.72-.314C3.488 11.43 2.2 9.544 2.2 7.498 2.2 4.576 4.75 2.2 7.884 2.2h6.232c3.134 0 5.684 2.376 5.684 5.298s-2.55 5.298-5.684 5.298v.004Z"
            />
            <path
                fill={color}
                fillRule="nonzero"
                d="M11.097 6.444a1.3 1.3 0 1 0 1.296 1.307 1.311 1.311 0 0 0-1.296-1.307ZM6.818 6.444a1.3 1.3 0 1 0-.036 2.6 1.3 1.3 0 0 0 .036-2.6ZM15.398 6.444a1.3 1.3 0 1 0-.036 2.6 1.3 1.3 0 0 0 .036-2.6Z"
            />
        </g>
    </SVG>
);

ChatBubble.displayName = "ChatBubble";
